import Row from 'iview/src/components/grid/row';
<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>学生状态审核</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form :label-width="100" :show-message="false" label-postion="right">
        <Row :gutter="16">
          <Col
            :xs="{span: 24}"
            :sm="{span: 12}"
            :md="{span: 8}"
            :lg="{span: 6}">
            <Form-item label="学生">
              <Input v-model="queryParam.uid" placeholder="学生ID/中文名/英文名"></Input>
            </Form-item>
          </Col>
          <Col
            :xs="{span: 24}"
            :sm="{span: 12}"
            :md="{span: 8}"
            :lg="{span: 6}">
            <Form-item label="变更后状态">
              <Select v-model="queryParam.afterStatusRecord" clearable placeholder="请选择" style="width: 100%">
                <Option v-for="item in $constant.studentStatusAudit" :value="item.code" :key="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col
            :xs="{span: 24}"
            :sm="{span: 12}"
            :md="{span: 8}"
            :lg="{span: 6}">
            <Form-item label="申请人">
              <sales-adviser-select v-model="queryParam.createdId" style="width: 100%"></sales-adviser-select>
            </Form-item>
          </Col>

          <Col
            :xs="{span: 24}"
            :sm="{span: 12}"
            :md="{span: 8}"
            :lg="{span: 6}">
            <Form-item label="审核状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择" style="width: 100%">
                <Option value="1" key="1">已通过</Option>
                <Option value="2" key="2">已驳回</Option>
                <Option value="0" key="3">待审核</Option>
              </Select>
            </Form-item>
          </Col>
          <Col
            :xs="{span: 24}"
            :sm="{span: 12}"
            :md="{span: 8}"
            :lg="{span: 6}">
            <Form-item label="申请提交时间:">
              <DatePicker @on-change="timeDateChange" format="yyyy-MM-dd" type="daterange" placement="bottom-start"
                          placeholder="选择起始时间" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <Row class-name="btn-container" :gutter="12">
      <Col
        :xs="{span: 24}"
        :sm="{span: 12}"
        :md="{span: 8}"
        :lg="{span: 2}">
        <Button type="primary" :loading="searchLoading" :disabled="searchLoading" icon="search" @click="search" long>搜索
        </Button>
      </Col>
      <Col
        :xs="{span: 24}"
        :sm="{span: 12}"
        :md="{span: 8}"
        :lg="{span: 2}">
        <Button type="primary" :loading="searchLoading" :disabled="searchLoading" @click="showPassAll" long>批量审核通过
        </Button>
      </Col>
      <Col
        :xs="{span: 24}"
        :sm="{span: 12}"
        :md="{span: 8}"
        :lg="{span: 2}">
        <Button type="primary" :loading="searchLoading" :disabled="searchLoading" @click="showRefusedAll" long>
          批量审核拒绝
        </Button>
      </Col>
    </Row>
    <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/userstatusreview/page"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
    <Modal title="请填写拒绝理由" v-model="showWhyNotModal">
      <Form class="form" ref="WhyNot" :model="auditParams">
        <Row>
          <Col :span="20">
            <FormItem label="拒绝理由">
              <Input v-model="auditParams.refuse" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                     placeholder="请输入拒绝原因"/>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" :loading="loadingWhyNot" @click="audit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      showWhyNotModal: false,
      loadingWhyNot: false,
      selectionUser: [],
      reload: 0,
      queryParam: {
        createdId: '',
        uid: '',
        beforeStatusRecord: '',
        afterStatusRecord: '',
        beginTime: '',
        endTime: '',
        status: ''
      },
      auditParams: {
        ids: 0,
        status: '',
        refuse: ''
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学生ID/姓名',
          align: 'center',
          // width: 120,
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.nickName)
          }
        },
        {
          title: '学生等级',
          // width: 100,
          align: 'center',
          key: 'platLevel'
        },
        {
          title: '课时信息',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let num = row.routineNum - row.routineEndNum
            return h('div', [
              h('div', '外教课课时：' + row.routineNum),
              h('div', '陪练课课时：' + row.partnerNum),
              h('div', '中教课课时：' + row.chineseNum),
              h('div', '外教课课时消耗：' + row.routineEndNum),
              h('div', '剩余外教课课时：' + num)
            ])
          }
        },
        {
          title: '状态变更',
          // width: 170,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let before = row.beforeStatusRecord ? $constant.getEnum($constant.studentStatusAudit, row.beforeStatusRecord).text : '未知状态'
            let after = row.afterStatusRecord ? $constant.getEnum($constant.studentStatusAudit, row.afterStatusRecord).text : '未知状态'
            return h('div', before + ' —> ' + after)
          }
        },
        {
          title: '申请人',
          // width: 80,
          align: 'center',
          key: 'createdName'
        },
        {
          title: '申请原因',
          // width: 180,
          align: 'center',
          key: 'description'
        },
        {
          title: '拒绝理由',
          // width: 180,
          align: 'center',
          key: 'refuse'
        },
        {
          title: '审批状态',
          // width: 100,
          align: 'center',
          key: 'status',
          render: (h, params) => {
            let text = ''
            switch (params.row.status) {
              case 1:
                text = '已通过'
                break
              case 2:
                text = '已驳回'
                break
              default:
                text = '待审核'
                break
            }
            return h('div', text)
          }
        },
        {
          title: '提交时间',
          width: 120,
          align: 'center',
          key: 'createTime'
        },
        {
          title: '审批时间',
          width: 120,
          align: 'center',
          key: 'reviewTime'
        },
        {
          title: '操作',
          // width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.status === 0) {
              return h('div', [
                h('a', {on: {click: () => this.showPass(row)}}, '通过'),
                h('br', '  '),
                h('a', {on: {click: () => this.showRefused(row)}}, '拒绝'),
              ])
            } else {
              return
            }
          }
        }
      ]
    }
  },
  methods: {
    timeDateChange (value) {
      let self = this
      self.queryParam.beginTime = value[0] + ' 00:00:00'
      self.queryParam.endTime = value[1] + ' 23:59:59'
    },
    showPassAll () {
      let self = this
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      }
      self.$Modal.confirm({
        title: '确认通过吗',
        content: '通过后及时通知对应学导或者教务服务学员',
        width: 300,
        okText: '确认',
        onOk: () => {
          self.auditParams.ids = ids.join(',')
          self.auditParams.status = 1
          self.audit()
        }
      })
    },
    showPass (row) {
      let self = this
      self.$Modal.confirm({
        title: '确认通过吗',
        content: '通过后及时通知对应学导或者教务服务学员',
        width: 300,
        okText: '确认',
        onOk: () => {
          self.auditParams.ids = row.id
          self.auditParams.status = 1
          self.audit()
        }
      })
    },
    showRefusedAll () {
      let self = this
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      }
      self.auditParams.ids = ids.join(',')
      self.auditParams.status = 2
      this.showWhyNotModal = true
    },
    showRefused (row) {
      let self = this
      self.auditParams.ids = row.id
      self.auditParams.status = 2
      this.showWhyNotModal = true
    },
    audit () {
      let self = this
      self.$http.post('/userstatusreview/batchreviewstatus', self.auditParams).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('成功')
          this.showWhyNotModal = false
          this.search()
          this.auditParams.refuse = ''
        }
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    cancel () {
      this.showWhyNotModal = false
      this.auditParams.refuse = ''
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    search () {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    selectionChange (selection) {
      this.selectionUser = selection
    }
  }
}
</script>

<style scoped>
  .btn-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 24px;
    margin-bottom: 12px;
    gap: 10px;
  }

  /* 在较大屏幕上水平排列按钮 */
  @media (min-width: 768px) {
    .btn-wrap {
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
  }

  /* 调整表单间距 */
  .ivu-form-item {
    margin-bottom: 16px;
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .ivu-form-item-label {
      padding-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// UserStatusAuditList.vue?9ea67e70